export default {
  "content": "<path d=\"M288.6 360.6H31.3c-17.8 0-26.7-21.5-14.1-34.1l128.6-128.7c7.8-7.8 20.5-7.8 28.3 0l128.6 128.7c12.6 12.6 3.7 34.1-14.1 34.1z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 320 512"
  }
};